/** Body for POST /seo/preview. Kept pure so the form and the server see the same fields. */
export function cmsPreviewRequest(resource, values) {
  const doc = values || {};
  return {
    resource: resource || "custom",
    document: {
      title: doc.title || doc.name || "",
      name: doc.name || "",
      slug: doc.slug || "",
      status: doc.status || "draft",
      excerpt: doc.excerpt || "",
      description: doc.description || doc.desc || "",
      desc: doc.desc || "",
      content: doc.content || "",
      sections: Array.isArray(doc.sections) ? doc.sections : [],
      featured_image: doc.featured_image || doc.cover_image || doc.media || "",
      cover_image: doc.cover_image || "",
      media: doc.media || null,
      seo: doc.seo || {},
    },
  };
}

export function seoPagePreviewRequest(page) {
  const current = page || {};
  return {
    page: {
      name: current.name || "",
      path: current.path || "/",
      url: current.url || "",
      page_type: current.page_type || "custom",
      seo: current.seo || {},
      technical: current.technical || {},
      social: current.social || {},
      schema: current.schema || {},
      keywords: current.keywords || [],
      content: current.content || {},
    },
  };
}
